import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { storage } from '@/configs/storage';
import { TUTORIAL_STORE_KEY } from '@/features/tutorial/constants/store';

export type TutorialStore = {
  cardVisible: boolean;
  /** True once the user has clicked through the whole tour at least once. */
  completed: boolean;
  hideCard: () => void;
  markCompleted: () => void;
};

export const useTutorialStore = create<TutorialStore>()(
  persist(
    (set) => ({
      cardVisible: true,
      completed: false,
      hideCard: () => set({ cardVisible: false }),
      markCompleted: () => set({ completed: true })
    }),
    {
      name: TUTORIAL_STORE_KEY,
      storage: createJSONStorage(() => storage)
    }
  )
);
